import React, { useEffect, useState } from 'react';
import {
  Stack,
  Button,
  TextField,
  Typography,
  Box,
  Grid,
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
} from '@mui/material';
import useErrorMessagesRequest from '../../../../requests/ErrorMessagesRequest';
import CustomModal from '../../../common/CustomModal';

const EditModal = ({ show, onHide, errorMessage, onSave, errorHandler }) => {
  const [editedMessage, setEditedMessage] = useState('');
  const [code, setCode] = useState('');
  const [level, setLevel] = useState('');
  const [subjectTransCode, setSubjectTransCode] = useState('');
  const [patterns, setPatterns] = useState({});
  const [messageExample, setMessageExample] = useState('');
  const { getPatterns, updateErrorMessage, createErrorMessage } =
    useErrorMessagesRequest();

  useEffect(() => {
    if (!errorMessage) return;

    setEditedMessage(errorMessage.error_text || '');
    setCode(errorMessage.error_code || '');
    setLevel(errorMessage.error_level || '');
    setSubjectTransCode(errorMessage.subject_trans_code || '');
  }, [errorMessage]);

  useEffect(() => {
    getPatterns(errorHandler).then((p) => setPatterns(p));
  }, []);

  useEffect(() => {
    const filledErrorText = editedMessage.replace(
      /{\((\w+)\)}/g,
      (match, key) => {
        if (patterns[key]) {
          return patterns[key];
        }

        console.error(`Replacement for ${key} not found`);

        return match;
      }
    );

    setMessageExample(filledErrorText);
  }, [editedMessage, patterns]);

  const handleSave = async () => {
    const message = {
      ...errorMessage,
      error_code: code,
      error_level: level,
      subject_trans_code: subjectTransCode,
      error_text: editedMessage,
    };

    delete message.fallback;

    if (message.error_messages_id) {
      await updateErrorMessage(
        message.error_messages_id,
        message,
        errorHandler
      );
    } else {
      await createErrorMessage(message, errorHandler);
    }

    onSave();
  };

  return (
    <CustomModal
      title="Edit Error Message"
      open={show}
      handleClose={onHide}
      width={1300}
    >
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Stack gap={2}>
            <TextField
              required
              id="errorCode"
              label="Code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              fullWidth
              size="small"
            />
            <TextField
              required
              id="errorLevel"
              label="Level"
              value={level}
              onChange={(e) => setLevel(e.target.value)}
              fullWidth
              size="small"
            />
            <TextField
              id="subjectTransCode"
              label="Subject Trans Code"
              value={subjectTransCode}
              onChange={(e) => setSubjectTransCode(e.target.value)}
              fullWidth
              size="small"
            />
            <TextField
              required
              id="editedMessage"
              label="Message"
              value={editedMessage}
              onChange={(e) => setEditedMessage(e.target.value)}
              multiline
              rows={3}
              fullWidth
              size="small"
            />

            <Box>
              <Typography>Message Example</Typography>
              <Typography>{messageExample}</Typography>
            </Box>
          </Stack>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Pattern</TableCell>
                <TableCell>Example Replacement</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.keys(patterns).map((pattern) => (
                <TableRow key={pattern}>
                  <TableCell>{pattern}</TableCell>
                  <TableCell>{patterns[pattern]}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Grid>
      </Grid>

      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
        <Button variant="outlined" color="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="contained" color="secondary" onClick={handleSave}>
          Save changes
        </Button>
      </Box>
    </CustomModal>
  );
};

export default EditModal;
